const ErrorView = () => {
    return <div>404</div>;
};

export default ErrorView;
